import script from "./replacementofgoods.vue?vue&type=script&setup=true&lang=js"
export * from "./replacementofgoods.vue?vue&type=script&setup=true&lang=js"

import "./replacementofgoods.vue?vue&type=style&index=0&id=e08c93da&lang=scss"
import "./replacementofgoods.vue?vue&type=style&index=1&id=e08c93da&lang=scss&scoped=scoped"

import exportComponent from "D:\\工作项目\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e08c93da"]])

export default __exports__